/* src/app/modules_v2/booking/media/components/location-branding/location-branding.component.css */
.branding-container {
  padding: 20px;
}
h3 {
  color: var(--cf-chrome);
  margin-bottom: 16px;
}
/*# sourceMappingURL=location-branding.component.css.map */
